import { Box, styled } from '@mui/joy';
import { CSSProperties } from 'react';

interface IProps {
  fullWidth?: boolean;
  style: CSSProperties;
}

const propsToSkip: PropertyKey[] = ['fullWidth'];
const shouldForwardProp = (propName: PropertyKey) => !propsToSkip.includes(propName);

export const FieldWrapper = styled(Box, { shouldForwardProp })<IProps>(({ fullWidth, style }) => ({
  width: fullWidth ? '100%' : 'inherit',

  ...style,
}));
